import { createBootstrap } from 'bootstrap-vue-next';
import type { App, Plugin } from 'vue';

/**
 * Installs only BootstrapVueNext's shared configuration. Feature SFCs import
 * every app-owned component and Bootstrap primitive they use so this plugin
 * does not turn back into a global catch-all component adapter.
 */
export const AppStudioBootstrapPlugin: Plugin = {
    install(app: App): void {
        app.use(createBootstrap());
    }
};
